import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

const LandingHeader = ({ data }) => {
  return (
    <div className="">
      <div className="fixed top-0 left-0 right-0 z-50 flex items-center justify-center px-[20px] md:px-10 py-2.5 bg-primary text-white">
        <div>
          <a href="tel:+16178929674">(617) 892-9674</a>
        </div>
      </div>
      <header>
        <div class="relative bg-white mt-5">
          <div class="relative px-4 mx-auto sm:px-6 lg:px-8">
            <nav class="flex items-center h-16 lg:h-20">
              <div class="">
                <a href="#" title="" class="flex">
                  <GatsbyImage
                    image={data?.logo2?.asset?.gatsbyImageData}
                    alt={data?.data?.logo2?.alt}
                    loading="eager"
                    priority
                    class="w-40 h-14 object-contain"
                    objectFit="contain"
                  />
                </a>
              </div>

              {/* <a
              href="#"
              title=""
              class="items-center justify-center hidden px-6 py-3 text-base font-semibold text-black transition-all duration-200 bg-yellow-400 border border-transparent rounded-full lg:inline-flex hover:bg-yellow-500 focus:bg-yellow-500"
              role="button"
              >
              {" "}
              Join Now{" "}
              </a> */}
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
};

export default LandingHeader;
